import { Injectable } from '@angular/core';
import { Headers, RequestOptions, URLSearchParams, Http } from '@angular/http';

import 'rxjs/add/operator/toPromise';

import { FamilyModel } from '../model/index';
@Injectable()
export class FamilyService {
    private headers = new Headers({
       'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
    });
    private familyUrl = 'api/family';  // URL to web api

    constructor(private http: Http) { }

    private extractData(res: any) {
        let body = res.json();
        return body || [];
    }

    getFamilyList(query: any): Promise<FamilyModel[]> {
        let params: URLSearchParams = new URLSearchParams();
        for (let key in query) {
            params.set(key.toString(), query[key]);
        }

        let options = new RequestOptions({
            headers: this.headers,
            search: params
        });

        const url = `${this.familyUrl}/familyList`;
        return this.http.get(url, options)
            .toPromise()
            .then(this.extractData)
            .catch(this.handleError);
    }

    deleteFamily(familyID: any): Promise<FamilyModel> {
       const url = `${this.familyUrl}/deleteFamily`;
       return this.http
           .post(url, $.param({ family_id: familyID }), { headers: this.headers })
           .toPromise()
           .then(res => res.json() as FamilyModel)
           .catch(this.handleError);
   }

   addUpdateFamily(familyData: any): Promise<FamilyModel> {

       const url = `${this.familyUrl}/addUpdateFamily`;

       return this.http
           .post(url, $.param(familyData), { headers: this.headers })
           .toPromise()
           .then(res => res.json() as FamilyModel)
           .catch(this.handleError);
   }

    private handleError(error: any): Promise<any> {
        console.error('An error occurred', error); // for demo purposes only
        return Promise.reject(error.message || error);
    }
}



// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/crm-soundsgood/src/app/services/family.service.ts